import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { useLgScreenMediaQuery } from "@/react/hooks/useMediaQuery";

import { CheckoutDescription } from ".";
import { CheckoutForm } from "../CheckoutForm";
import { PricePreview } from "../CheckoutForm/PricePreview";
import { Column } from "../components/Column";
import { PaywallCustomization } from "./PaywallCustomization";
import { PaywallDetail } from "./PaywallDetail";

interface RootProps {
  className?: string;
  dataTestId?: string;
}

export const Paywall = Object.assign(
  ({ className, dataTestId = "paywall-checkout-left-column" }: RootProps) => {
    const { authProviderProperties, paywall, currentCommunity } =
      usePaywallCheckoutContext();
    const isLgOrLargerScreen = useLgScreenMediaQuery();

    return (
      <Column
        className={classNames(
          "flex flex-row-reverse justify-center lg:justify-normal",
          className,
          {
            "pointer-events-none !hidden opacity-60 lg:!flex":
              authProviderProperties?.is_sso_authentication_required,
          },
        )}
        dataTestId={dataTestId}
      >
        <div className="flex flex-col gap-y-2">
          <CheckoutDescription.CommunityHeader community={currentCommunity} />
          <PaywallCustomization.Countdown />
          <div
            className="bg-primary border-primary flex h-fit w-full flex-col rounded-xl border shadow-lg"
            data-testid="paywall-checkout-info"
          >
            <CheckoutDescription.CoverImage.Checkout paywall={paywall} />
            <div className="flex flex-col gap-y-4 p-4 pb-5 md:p-7">
              <div className="flex flex-col gap-6">
                <PaywallDetail />
                <CheckoutDescription.PriceSelector />
              </div>
              <CheckoutForm.CouponForm className="pb-4" />
              <PricePreview variant="with_modals" />
            </div>
          </div>
        </div>
        <PaywallCustomization.List
          shouldHide={!isLgOrLargerScreen}
          className="px-4"
        />
      </Column>
    );
  },
  {
    Skeleton: ({ className }: RootProps) => (
      <Column
        className={classNames(
          "flex flex-row-reverse justify-center lg:justify-normal",
          className,
        )}
      >
        <div className="flex flex-col gap-y-2">
          <Row
            square
            full
            x2l
            className="!h-[2.5rem] lg:!h-10 my-[1.625rem] md:my-[2.625rem] !w-full lg:!w-1/2"
          />
          <div
            className="bg-primary border-primary flex h-fit w-full flex-col rounded-xl border shadow-lg"
            data-testid="paywall-checkout-info"
          >
            <div className="flex flex-col gap-y-4 p-4 pb-5 md:p-7">
              <div className="flex flex-col gap-6">
                <Row full x2l />
                <Row full square className="!h-[150px] !w-full" />
                <Row full x2l />
              </div>
              <Row full x2l className="!h-[50px] !w-full" />
            </div>
          </div>
        </div>
      </Column>
    ),
  },
);
